module.exports = __webpack_public_path__ + "static/stm-digital-pazarlama-1c536c2ff293586c82f9ba9b0ac1bb33.webp";